"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageProductImport = void 0;
var _react = _interopRequireDefault(require("react"));
var _DmsPage = require("../../components/DmsPage/DmsPage");
var _DmsUploadFile = require("../../components/DmsUploadFile/DmsUploadFile");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsPageProductImport Component
 * 
 * @description Component for importing product files. Displays a DmsPage layout with a DmsUploadFile Product for managing Product file import operations.
 * 
 * @component
 * @example
 * return (
 *   <DmsPageProductImport />
 * )
 * 
 * @returns {JSX.Element} The Import Product File page.
 */
const DmsPageProductImport = () => {
  return /*#__PURE__*/_react.default.createElement(_DmsPage.DmsPage, {
    name: "Import Component File"
  }, /*#__PURE__*/_react.default.createElement(_DmsUploadFile.DmsUploadFile, {
    table_url: "/product/files/table",
    upload_url: "/product/file_upload",
    import_url: "/product/file_import",
    download_url: "/file/download"
  }));
};
exports.DmsPageProductImport = DmsPageProductImport;